var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7918 7.95708C18.9245 3.4596 14.7615 0 10.0781 0C5.74167 0 1.92557 2.76768 0.537902 6.74622C-0.849769 10.7248 0.537902 15.2222 3.66016 17.817C6.95588 20.4117 11.6393 20.7576 15.2819 18.5089C18.7511 16.2601 20.6591 12.1086 19.7918 7.95708ZM15.8023 16.6061C13.0269 19.0278 9.03739 19.3738 5.74167 17.644C2.61941 15.7412 0.711361 12.1086 1.4052 8.47603C2.09903 4.3245 5.74167 1.38384 10.0781 1.21086C13.7208 1.21086 17.0165 3.4596 18.2307 6.9192C19.4449 10.3788 18.4042 14.1844 15.8023 16.6061Z",
    fill: "#BB4048"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0775 4.84375C10.7713 4.84375 11.2917 5.36269 11.1182 6.05461L10.4244 12.4549C10.4244 12.6279 10.251 12.8008 10.0775 12.8008C9.90404 12.8008 9.73058 12.6279 9.73058 12.4549L8.86328 6.05461C8.86328 5.36269 9.38366 4.84375 10.0775 4.84375Z",
    fill: "#BB4048"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0776 15.0521C10.4608 15.0521 10.7715 14.7422 10.7715 14.36C10.7715 13.9778 10.4608 13.668 10.0776 13.668C9.69443 13.668 9.38379 13.9778 9.38379 14.36C9.38379 14.7422 9.69443 15.0521 10.0776 15.0521Z",
    fill: "#BB4048"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListError);
export default __webpack_public_path__ + "static/media/list_error.2067fec6d36e874e7aaeaf19dc58d492.svg";
export { ForwardRef as ReactComponent };